import { INVOICES_CREATE } from '../../constants/Tools';
/**
 * Converts a legacy Invoices Create action to a V2 compatible format
 * @param inAppActionLegacy The legacy action to convert
 * @returns The converted action in V2 format
 */
export const convertInvoicesCreateAction = inAppActionLegacy => {
  return {
    name: INVOICES_CREATE,
    arguments: {
      '@type': 'map',
      value: {
        intent: {
          '@type': 'string',
          value: inAppActionLegacy.intent
        }
        // TODO - `product` - handle since V1 does not support that data
        // TODO - `contact` - handle since V1 does not support that data
      }
    }
  };
};